import { z } from "zod";
export const GetHomepageResponse = z.object({
    userId: z.string(),
    featured: z.record(z.string(), z.unknown()).nullable(),
    secondary: z.array(z.record(z.string(), z.unknown())).nullable(),
    updatedAt: z.string(),
});
//# sourceMappingURL=homepage.js.map